var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStreamlineView(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 13.81c-3.7-.06-7.52 2.52-9.92 5.17a1.53 1.53 0 000 2c2.35 2.59 6.16 5.23 9.92 5.17s7.57-2.58 9.92-5.17a1.53 1.53 0 000-2c-2.4-2.65-6.23-5.23-9.92-5.17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.44 20A3.44 3.44 0 1120 16.56 3.44 3.44 0 0123.44 20z"
  }))));
}
export default SvgStreamlineView;